<template>
<div>
   <pt-promotion-form-with-data ref="promotionForm" @submitLoad="submitLoad" @submitOver="submitOver" :is-edit="isEdit" :id="id" :isActive="isActive"></pt-promotion-form-with-data>
   <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button type="primary" @click="cancel" plain>取消</el-button>
    </div>
</div>
</template>
<script>
import PtPromotionFormWithData from './withData.vue'
export default {
  components: {
    PtPromotionFormWithData
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      submitLoading: false
    }
  },
  methods: {
    cancel () {
      history.go(-1)
    },
    submit () {
      this.$refs.promotionForm.submit()
    },
    submitLoad () {
      this.submitLoading = true
    },
    submitOver () {
      this.submitLoading = false
    }
  }
}
</script>
<style lang="less">

</style>
